export type ColorsTypes = typeof colors;

export const colors = {
  $black: "#000000",
  $gray: "#969696",
  $white: "#FFFFFF",
  $purple: "#6600CC",
  $whiteGray: "#f4f4f4",
  $darkGray: "#3D3D3D",
  $middleGray: "#595959",
};
